module.exports = __webpack_public_path__ + "static/media/Logo.ceecab86.svg";